<template>
  <div class="p-contactUs">
    <div class="__ban kf-animate kf-animate-img">
      <div class="__ban_cap">联系我们</div>
    </div>
    <div class="g-box">
      <div class="__list">
        <div v-for="(item, index) in list" :key="index" class="__list_item">
          <div class="__list_cap">{{ item.title }}</div>
          <div class="__list_text" v-html="item.content"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import page_mx from "@/mixin/page_mx";

export default {
  mixins: [page_mx],
  data() {
    return {
      pageSize: 10000000,
    };
  },
  components: {},
  mounted() {},
  methods: {
    async init() {
      this.params = this.$route.params;
      await this.getListAndInfo();
    },
  },
};
</script>
<style lang="less">
.p-contactUs {
  padding-bottom: 120px;
  .__ban {
    background: url("../../assets/img/ico_13.png") no-repeat center;
    background-size: cover;
    height: 280px;
    display: flex;
  }
  .__ban_cap {
    letter-spacing: 0.7em;
    font-size: 60px;
    color: #ffffff;
    line-height: 84px;
    margin: auto;
  }
  .__list {
    display: flex;
    flex-wrap: wrap;
    padding-top: 20px;
  }
  .__list_item {
    width: 520px;
    background: #f2f4f9;
    margin-top: 40px;
    margin-right: 60px;
    padding: 20px 30px 36px 30px;
    box-sizing: border-box;
    &:nth-child(2n) {
      margin-right: 0;
    }
  }
  .__list_cap {
    font-size: 18px;
    color: #0030aa;
    line-height: 25px;
    padding-left: 12px;
    position: relative;
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      width: 2px;
      height: 18px;
      margin-top: -9px;
      background: #0030aa;
    }
  }
  .__list_text {
    font-size: 14px;
    color: #656878;
    line-height: 22px;
    margin-top: 19px;
  }
}
</style>
